import React from "react";

import * as typography from "@client/shared/typography";

import * as journeys from "@client/journeys";
import {ManagerLayout} from "@client/site/ManagerLayout";
import {useSiteContext} from "@client/site/context";
import * as forms from "@client/site/forms";
import {server} from "@reactivated";

export const Template = () => {
    const {profile} = useSiteContext();

    const [fromExerciseType, setFromExerciseType] =
        React.useState<server.journal.workouts.ExerciseType.output | null>(null);
    const [toExerciseType, setToExerciseType] =
        React.useState<server.journal.workouts.ExerciseType.output | null>(null);
    const exercisesDialog = journeys.useExercisesDialog();

    return (
        <ManagerLayout title="Merge exercises" narrow currentClientManagerId={null}>
            <form method="POST" action="" className="space-y-2">
                {exercisesDialog.dialog}
                <forms.CSRFToken />
                <div>
                    I want to merge{" "}
                    <button
                        type="button"
                        className="font-semibold"
                        onClick={async () => {
                            const result = await exercisesDialog({disableCreate: true});

                            if (result != null) {
                                setFromExerciseType(result[0]);
                            }
                        }}
                    >
                        {fromExerciseType?.name ?? "[select exercise]"}
                    </button>{" "}
                    with{" "}
                    <button
                        type="button"
                        className="font-semibold"
                        onClick={async () => {
                            const result = await exercisesDialog({disableCreate: true});

                            if (result != null) {
                                setToExerciseType(result[0]);
                            }
                        }}
                    >
                        {toExerciseType?.name ?? "[select exercise]"}
                    </button>
                </div>
                {fromExerciseType != null &&
                    toExerciseType != null &&
                    fromExerciseType.user_id == profile?.user.id && (
                        <div>
                            <strong>{fromExerciseType.name}</strong> is a custom
                            exercise, so it will be deleted afterwards.
                        </div>
                    )}

                <typography.Button
                    disabled={fromExerciseType == null || toExerciseType == null}
                    variant="indigo"
                    submit
                >
                    Submit
                </typography.Button>
                <input
                    type="hidden"
                    name="from"
                    defaultValue={fromExerciseType?.uuid}
                />
                <input type="hidden" name="to" defaultValue={toExerciseType?.uuid} />
            </form>
        </ManagerLayout>
    );
};
